export enum DrawerOperation {
  create = 'create',
  delete = 'delete',
  read = 'read',
  update = 'update',
}
